import styled from 'styled-components';

/* ----------------------------------
   Online Access
----------------------------------- */

export const OnlineAccessSection = styled.section`
  width: 100%;

  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(280px, 0.9fr);
  gap: var(--space-xxxl);

  align-items: center;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: var(--space-xl);
  }
`;

export const OnlineAccessContent = styled.div`
  h2 {
    margin: var(--space-xs) 0 var(--space-m);

    color: var(--grey7);

    font-size: clamp(2rem, 3.5vw, 3rem);
    line-height: 1.05;
    font-weight: 900;
    letter-spacing: -0.035em;
  }

  > p:not(.eyebrowHeader) {
    max-width: 700px;

    margin: 0 0 var(--space-m);

    color: var(--grey4);

    font-size: 1rem;
    line-height: 1.8;
  }
`;

export const TextLink = styled.a`
  margin-top: var(--space-s);

  width: fit-content;

  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);

  color: var(--grey7);

  font-size: 0.9rem;
  font-weight: 900;

  text-decoration: none;

  span {
    color: var(--orange5);
    transition: transform 0.2s ease;
  }

  &:hover {
    color: var(--orange5);

    span {
      transform: translateX(4px);
    }
  }
`;

export const AccessList = styled.div`
  border-top: 1px solid var(--grey);
`;

export const AccessItem = styled.div`
  padding: var(--space-l) 0;

  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: var(--space-m);

  align-items: flex-start;

  border-bottom: 1px solid var(--grey);

  strong {
    display: block;

    margin-bottom: var(--space-xxs);

    color: var(--grey7);

    font-size: 0.92rem;
    font-weight: 900;
  }

  span {
    color: var(--grey4);

    font-size: 0.85rem;
    line-height: 1.55;
  }
`;

export const AccessIcon = styled.div`
  width: 40px;
  height: 40px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  flex-shrink: 0;

  border-radius: 50%;

  background: var(--yellow1);
  color: var(--orange5);

  font-size: 0.95rem;
`;
